/**
 * Shared registry of live call instances (group SFU + 1:1 mesh).
 *
 * Home/App mount several call UIs at once. Accepting a call on one instance
 * must be able to leave/end the other instance's ongoing call first.
 *
 *   kind: 'group'  — mediasoup group audio/video
 *   kind: 'direct' — 1:1 (or mesh) audio/video
 */

const sessions = new Map();

export function registerCallSession(session) {
  if (!session?.id) return () => {};
  sessions.set(session.id, session);
  return () => {
    sessions.delete(session.id);
  };
}

export function registerGroupCallSession(session) {
  return registerCallSession({ kind: 'group', ...session });
}

export function isCallSessionActive(session) {
  try {
    return Boolean(session?.isActive?.());
  } catch (_) {
    return false;
  }
}

export function isGroupCallSessionActive(session) {
  return isCallSessionActive(session);
}

export async function leaveOtherCallSessions(exceptId, options = {}) {
  const kinds = options.kinds ? new Set(options.kinds) : null;
  const jobs = [];
  sessions.forEach((session, id) => {
    if (id === exceptId) return;
    if (kinds && session.kind && !kinds.has(session.kind)) return;
    if (!isCallSessionActive(session)) return;
    try {
      jobs.push(Promise.resolve(session.leave?.()));
    } catch (err) {
      console.warn('[callSession] failed to leave other call:', err?.message || err);
    }
  });
  if (jobs.length === 0) return 0;
  await Promise.allSettled(jobs);
  return jobs.length;
}

/** Leave every other active call (group and 1:1) so only one call stays live. */
export async function leaveOtherGroupCallSessions(exceptId) {
  return leaveOtherCallSessions(exceptId);
}
